<div class="site-page-header-ghost-wrapper">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title class="ml4">Reported Content</nz-page-header-title>
    <nz-page-header-extra class="mr4">
      <nz-tag nzColor="gold">{{ totalDataCount }} Total Reports</nz-tag>
    </nz-page-header-extra>
  </nz-page-header>
</div>

<!-- Tabs -->
<nz-tabset
  [(nzSelectedIndex)]="selectedTabIndex"
  (nzSelectedIndexChange)="onTabChange($event)"
  class="mt4"
>
  <!-- TAB 1 -->
  <nz-tab nzTitle="Pending">
    <ng-container *ngTemplateOutlet="filterBar"></ng-container>
    <ng-container *ngTemplateOutlet="reportTable"></ng-container>
  </nz-tab>

  <!-- TAB 2 -->
  <nz-tab nzTitle="Resolved & Rejected">
    <ng-container *ngTemplateOutlet="filterBar"></ng-container>
    <ng-container *ngTemplateOutlet="reportTable"></ng-container>
  </nz-tab>
</nz-tabset>

<!-- FILTER BAR -->
<ng-template #filterBar>
  <div nz-row nzJustify="end" [nzGutter]="16" class="mt4">
    <!-- Reason -->
    <div nz-col nzLg="6" nzMd="8" nzSm="24" nzXs="24" class="mb5">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Search by Reason</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-input-group [nzSuffix]="suffixSearch">
            <input
              nz-input
              placeholder="Search reason…"
              [ngModel]="reasonSearch"
              (ngModelChange)="onReasonSearch($event)"
            />
          </nz-input-group>
          <ng-template #suffixSearch>
            <i nz-icon nzType="search"></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Date Range -->
    <div nz-col nzLg="7" nzMd="8" nzSm="24" nzXs="24" class="mb5">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Date Range</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-range-picker
            class="width-100"
            [(ngModel)]="dateRange"
            (ngModelChange)="onChangeDateRange($event)"
          ></nz-range-picker>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</ng-template>

<!-- TABLE -->
<ng-template #reportTable>
  <nz-table
    #reportTbl
    [nzData]="allReports"
    [nzLoading]="loading"
    [nzTotal]="totalDataCount"
    [(nzPageSize)]="pageSize"
    [nzPageIndex]="pageIndex"
    [nzFrontPagination]="false"
    (nzQueryParams)="onQueryParamsChange($event)"
    nzShowSizeChanger
    [nzScroll]="{ x: '1300px' }"
  >
    <thead>
      <tr>
        <th nzWidth="55px">#</th>
        <th nzWidth="190px">Reported By</th>
        <th nzWidth="130px">Content Type</th>
        <th nzWidth="430px">Content Title</th>
        <th nzWidth="180px">Reason</th>
        <th nzWidth="90px">Status</th>
        <th nzWidth="120px">Reported On</th>

        <ng-container *ngIf="selectedTabIndex === 1">
          <th nzWidth="200px">Admin Note</th>
          <th nzWidth="150px">Actioned By</th>
        </ng-container>

        <th class="text-right" nzWidth="150px">Action</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let data of reportTbl.data; index as i">
        <!-- Serial -->
        <td>{{ (pageIndex - 1) * pageSize + i + 1 }}</td>

        <!-- Reported By -->
        <td>
          <span *ngIf="data.createdBy?.name; else noUser">
            <strong>{{ data.createdBy.name }}</strong
            ><br />
            <small class="text-muted">{{ data.createdBy.email }}</small
            ><br />
            <small *ngIf="data.createdBy.mobile" class="text-muted">
              📞 {{ data.createdBy.mobile }}
            </small>
          </span>
          <ng-template #noUser>—</ng-template>
        </td>

        <!-- Content Type -->
        <td>
          <nz-tag [nzColor]="getContentTypeColor(data)">
            <i
              nz-icon
              [nzType]="
                data.question
                  ? 'question-circle'
                  : data.editorial
                    ? 'read'
                    : 'file-text'
              "
            ></i>
            &nbsp;{{ getContentType(data) }}
          </nz-tag>
        </td>

        <!-- ✅ UPDATED CONTENT COLUMN -->
        <td>
          <div class="content-cell">
            <!-- Title -->
            <div
              nz-tooltip
              [nzTooltipTitle]="getContentName(data)"
              class="truncate"
            >
              <app-mathjax [content]="getContentName(data)"></app-mathjax>
            </div>

            <!-- ✅ EXTRA INFO FOR QUESTION -->
            <ng-container *ngIf="data.question">
              <div class="extra-info">
                <nz-tag *ngIf="data.test?.name" nzColor="blue">
                  {{ data.test.name }}
                </nz-tag>

                <nz-tag *ngIf="data.testSeries?.name" nzColor="purple">
                  {{ data.testSeries.name }}
                </nz-tag>
              </div>
            </ng-container>
          </div>
        </td>

        <!-- Reason -->
        <td>
          <span nz-tooltip [nzTooltipTitle]="data.reason" class="truncate">
            {{ data.reason }}
          </span>
        </td>

        <!-- Status -->
        <td>
          <nz-tag [nzColor]="getStatusColor(data.status)">
            {{ data.status | titlecase }}
          </nz-tag>
        </td>

        <!-- Date -->
        <td>{{ data.createdAt | date: "mediumDate" }}</td>

        <!-- Tab 2 Extra -->
        <ng-container *ngIf="selectedTabIndex === 1">
          <td>
            <span
              *ngIf="data.adminNote; else noNote"
              nz-tooltip
              [nzTooltipTitle]="data.adminNote"
              class="truncate"
            >
              {{ data.adminNote }}
            </span>
            <ng-template #noNote>—</ng-template>
          </td>

          <td>
            <span *ngIf="data.statusChangedBy?.name; else noAdmin">
              <strong>{{ data.statusChangedBy.name }}</strong
              ><br />
              <nz-tag nzColor="geekblue">
                {{ data.statusChangedBy.role | titlecase }}
              </nz-tag>
            </span>
            <ng-template #noAdmin>—</ng-template>
          </td>
        </ng-container>

        <!-- Actions -->
        <td class="action-buttons">
          <button
            nz-button
            nzSize="small"
            *ngIf="canNavigate(data)"
            (click)="navigateToUpdate(data)"
            nz-tooltip nzTooltipTitle="Edit Content"
          >
            <i nz-icon nzType="edit"></i>
          </button>

          <button
            nz-button
            nzSize="small"
            (click)="navigateToDetails(data._id)"
            nz-tooltip nzTooltipTitle="View Details"
          >
            <i nz-icon nzType="eye" style="color: #1890ff"></i>
          </button>

          <button
            nz-button
            nzSize="small"
            *ngIf="data.status === 'pending'"
            (click)="openActionModal(data._id, 'resolved')"
          >
            <i nz-icon nzType="check-circle" style="color: #52c41a"></i>
          </button>

          <button
            nz-button
            nzSize="small"
            *ngIf="data.status === 'pending'"
            (click)="openActionModal(data._id, 'rejected')"
          >
            <i nz-icon nzType="close-circle" style="color: #ff4d4f"></i>
          </button>

          <span *ngIf="data.status === 'resolved'" style="color: #52c41a">
            ✔ Resolved
          </span>

          <span *ngIf="data.status === 'rejected'" style="color: #ff4d4f">
            ✖ Rejected
          </span>
        </td>
      </tr>
    </tbody>
  </nz-table>
</ng-template>

<!-- Action Modal (Resolve / Reject) -->
<nz-modal
  [(nzVisible)]="adminNoteModalVisible"
  [nzTitle]="pendingAction?.status === 'resolved' ? 'Resolve Report' : 'Reject Report'"
  (nzOnCancel)="cancelAction()"
  (nzOnOk)="confirmAction()"
  [nzOkText]="pendingAction?.status === 'resolved' ? 'Resolve' : 'Reject'"
  [nzOkDanger]="pendingAction?.status === 'rejected'"
>
  <ng-container *nzModalContent>
    <div class="mb3">
      <p>
        Are you sure you want to <strong>{{ pendingAction?.status }}</strong> this report?
        You can optionally provide an admin note below.
      </p>
    </div>
    <nz-form-item>
      <nz-form-label [nzSpan]="24">Admin Note (Optional)</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <textarea
          nz-input
          rows="4"
          [(ngModel)]="adminNoteText"
          placeholder="Enter a brief note for the resolution..."
        ></textarea>
      </nz-form-control>
    </nz-form-item>
  </ng-container>
</nz-modal>
